import {
  IconRankingArrowDown,
  IconRankingSortAscending,
  IconRankingSortDescending,
} from "assets/svg";
import { Select } from "antd";
import { PRODUCT_CATEGORY } from "common/constants";
import React from "react";
import { RankingRole, RankingSortOrder } from "reducers/rankingApi";

interface RankingFiltersProps {
  rankingRole: RankingRole;
  onRoleChange: (role: RankingRole) => void;
}

interface RankingMaterialFilterProps {
  material: string;
  sortOrder: RankingSortOrder;
  onMaterialChange: (material: string) => void;
  onSortOrderChange: (sortOrder: RankingSortOrder) => void;
}

const materialOptions = Object.values(PRODUCT_CATEGORY);

const sortOrderOptions: Array<{ value: RankingSortOrder; label: string }> = [
  { value: "desc", label: "多い順" },
  { value: "asc", label: "少ない順" },
];

const RankingFilters = ({ rankingRole, onRoleChange }: RankingFiltersProps) => (
  <div className="flex w-full border-b border-[#d5d5d5]">
    {[
      ["seller", "売り手ランキング"],
      ["buyer", "買い手ランキング"],
    ].map(([role, label]) => {
      const active = rankingRole === role;
      return (
        <button
          key={role}
          type="button"
          onClick={() => onRoleChange(role as RankingRole)}
          className={`flex-none whitespace-nowrap border-b-4 px-3 py-1 text-sm font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-primary md:min-w-0 md:flex-1 md:max-w-[12.5rem] md:px-6 md:py-3 md:text-base ${
            active
              ? "border-primary text-primary"
              : "border-transparent text-[#bac7d5]"
          }`}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export const RankingMaterialFilter = ({
  material,
  sortOrder,
  onMaterialChange,
  onSortOrderChange,
}: RankingMaterialFilterProps) => {
  const nextSortOrder: RankingSortOrder = sortOrder === "desc" ? "asc" : "desc";
  const currentSortLabel =
    sortOrderOptions.find((option) => option.value === sortOrder)?.label ?? "";

  return (
    <div className="flex flex-wrap items-center gap-3.5 border-b border-white/60 px-2.5 py-2.5 text-sm text-white md:px-[0.9375rem] md:text-base">
      <div className="flex items-center gap-3.5">
        <label htmlFor="ranking-material" className="font-bold">
          対象素材：
        </label>
        <div className="h-10 w-[8.125rem] md:h-[3.125rem] md:w-[9.375rem]">
          <Select
            id="ranking-material"
            aria-label="対象素材"
            value={material}
            onChange={onMaterialChange}
            className="ranking-material-select h-full w-full"
            popupClassName="ranking-material-dropdown"
            suffixIcon={<IconRankingArrowDown className="h-1.5 w-2.5" />}
            options={[
              { value: "all", label: "全て" },
              ...materialOptions.map(({ value, label }) => ({ value, label })),
            ]}
          />
        </div>
      </div>

      <div className="ml-auto">
        <button
          type="button"
          aria-label={`表示順：${currentSortLabel}`}
          title={currentSortLabel}
          onClick={() => onSortOrderChange(nextSortOrder)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-[6px] bg-white text-primary shadow-[0_1px_4px_rgba(0,0,0,0.18)] transition hover:bg-[#eef5fa] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4F754] md:h-[3.125rem] md:w-[3.125rem]"
        >
          {sortOrder === "asc" ? (
            <IconRankingSortAscending className="h-8 w-8 fill-current" />
          ) : (
            <IconRankingSortDescending className="h-8 w-8 fill-current" />
          )}
        </button>
      </div>
    </div>
  );
};

export default RankingFilters;
